import { ROLES } from 'variables';
import { lazy } from 'react';

// project import
import Loadable from 'components/@ui/loader/Loadable';

// PROGRAMS
const Programs = Loadable(lazy(() => import('pages/merchant/prgoram-management/Programs')));
const Program = Loadable(lazy(() => import('pages/merchant/prgoram-management/program-details/ProgramDetailsPage')));
const Offer = Loadable(lazy(() => import('pages/merchant/offer-management/offer-details/OfferDetails')));
const CreateOffer = Loadable(lazy(() => import('pages/merchant/offer-management/offer-creation/OfferCreationPage')));
const PlanAllocation = Loadable(lazy(() => import('pages/merchant/license-management/license-allocation/LicenseAllocation')));
const SponsorshipsCreationPage = Loadable(
  lazy(() => import('pages/merchant/sponsorships-management/sponsorships-creation/SponsorshipsCreationPage'))
);

const ProgramCreationPage = Loadable(lazy(() => import('pages/merchant/prgoram-management/program-creation/ProgramCreationPage')));

// FINANCIALS
const Financials = Loadable(lazy(() => import('pages/merchant/financial-management/Financials')));
const Wallets = Loadable(lazy(() => import('pages/merchant/financial-management/wallet-management/WalletPage')));
const AddWalletFunds = Loadable(lazy(() => import('pages/merchant/financial-management/wallet-management/wallet-funding/FundWalletPage')));
const Transactions = Loadable(lazy(() => import('pages/merchant/financial-management/transaction-management/Transactions')));
const Transaction = Loadable(
  lazy(() => import('pages/merchant/financial-management/transaction-management/transaction-details/TransactionDetailsPage'))
);
const Payments = Loadable(lazy(() => import('pages/merchant/financial-management/payments-management/payments-listing/PaymentsTable')));
const Settlements = Loadable(lazy(() => import('pages/commons/settlement-management/settlement-listing/SettlementsTable')));
const Settlement = Loadable(lazy(() => import('pages/commons/settlement-management/settlement-details/SettlementDetailsPage')));

const ReceivableSettlements = Loadable(lazy(() => import('pages/commons/recievables-management/settlements/listing/RecSettlementsTable')));
const ReceivableSettlement = Loadable(lazy(() => import('pages/commons/recievables-management/settlements/details/RecSettlementPage')));

// CATEGORIES
const Categories = Loadable(lazy(() => import('pages/merchant/categories-management/categories-listing/CategoriesTable')));

const Category = Loadable(lazy(() => import('pages/merchant/categories-management/category-details/CategoryDetailsPage')));

// MERCHANTS
const Merchants = Loadable(lazy(() => import('pages/commons/merchant-management/merchants-listing/MerchantsTable')));

const MerchantCreationPage = Loadable(lazy(() => import('pages/commons/merchant-management/merchant-creation/MerchantCreationPage')));

// FINANCIALS
const Licenses = Loadable(lazy(() => import('pages/merchant/license-management/license-allocation/LicenseAllocation')));
const LicenseGenerations = Loadable(lazy(() => import('pages/merchant/license-management/license-generation/LicesneGeneration')));

// CLAIMS
const Claims = Loadable(lazy(() => import('pages/merchant/claims-management/listing/ClaimsTable')));

// Campaigns/Events
const Campaigns = Loadable(lazy(() => import('pages/merchant/event-management/event-listing/EventsTable')));
const CampaignCreation = Loadable(lazy(() => import('pages/merchant/event-management/event-creation/EventCreationPage')));

// SUPPORT
// const Support = Loadable(lazy(() => import('pages/common/support/SupportForm')));
const Support = Loadable(lazy(() => import('pages/common/support/Support')));

// const Support = Loadable(lazy(() => import('components/widgets/components/TimelineWidget')));

// SIMULATOR
// const Simulator = Loadable(lazy(() => import('pages/simulator/Simulator')));

// PRISEEN
const Items = Loadable(lazy(() => import('pages/merchant/items-management/items/items-listing/ItemsTable')));

const ItemCreationPage = Loadable(lazy(() => import('pages/merchant/items-management/items/items-creation/ItemCreationPage')));

const BundlesPage = Loadable(lazy(() => import('pages/merchant/bundles-management/listing/BundlesPage')));
const BundleDetailsPage = Loadable(lazy(() => import('pages/merchant/bundles-management/details/BundleViewer')));
const BundleCreationPage = Loadable(lazy(() => import('pages/merchant/bundles-management/mappings/BundleMappingPage')));
const BundleMappingPage = Loadable(lazy(() => import('pages/merchant/bundles-management/mappings/BundleMappingPage')));

const Tags = Loadable(lazy(() => import('pages/merchant/items-management/tags/tags-listing/TagsTable')));
const TagsPage = Loadable(lazy(() => import('pages/merchant/items-management/tags/tags-listing/TagsPage')));

const ItemCategories = Loadable(lazy(() => import('pages/merchant/items-management/categories/categories-listing/ItemCategoriesTable')));

const StoresPage = Loadable(lazy(() => import('pages/merchant/store-management/Stores')));
const Stores = Loadable(lazy(() => import('pages/merchant/store-management/listing/StoresTable')));
const Store = Loadable(lazy(() => import('pages/merchant/store-management/details/StoreDetailsPage')));
const StoreCreationPage = Loadable(lazy(() => import('pages/merchant/store-management/creation/StoreCreationPage')));

const CataloguesPage = Loadable(lazy(() => import('pages/merchant/catalogues-management/Catalogues')));
const Menus = Loadable(lazy(() => import('pages/merchant/catalogues-management/menus/listing/Menus')));

const ChildAccounts = Loadable(lazy(() => import('pages/merchant/child-accounts-management/listing/ChildAccountsTable')));
const UserCreation = Loadable(lazy(() => import('pages/merchant/child-accounts-management/creation/ChildAccountCreationPage')));

const AppUsers = Loadable(lazy(() => import('pages/merchant/app-users-management/listing/AppUsersTable')));
const AppUserCreation = Loadable(lazy(() => import('pages/merchant/app-users-management/creation/AppUserCreationPage')));

// assets
import CampaignIcon from '@mui/icons-material/Campaign';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CalculateIcon from '@mui/icons-material/Calculate';
import ReceiptIcon from '@mui/icons-material/Receipt';
import GroupsIcon from '@mui/icons-material/Groups';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import FastfoodOutlinedIcon from '@mui/icons-material/FastfoodOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import FestivalIcon from '@mui/icons-material/Festival';
import { TabletSmartphone } from 'lucide-react';
import GroupIcon from '@mui/icons-material/Group';
import PriseenRoutesLayout from 'layout/PageSpecificLayouts/PriseenRoutesLayout';
// icons
const icons = {
  CampaignIcon,
  HandshakeOutlinedIcon,
  StorefrontIcon,
  CalculateIcon,
  ReceiptIcon,
  GroupsIcon,
  VolunteerActivismIcon,
  PaymentIcon,
  AccountBalanceWalletIcon,
  TabletSmartphone,
  StorefrontOutlinedIcon,
  ReceiptLongOutlinedIcon,
  CategoryOutlinedIcon,
  FastfoodOutlinedIcon,
  MenuBookOutlinedIcon,
  GroupIcon,
  FestivalIcon
  // Add more icons as needed
};

//======================= VASEELAH ADMIN ROUTES ===================================//
export const merchantRoutes = [
  // BENEFICIARIES
  // {
  //   path: 'employees',
  //   element: <Employees />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },
  // {
  //   path: 'employees/add',
  //   element: <AddEmployees />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },
  // {
  //   path: 'employees/:employeeId',
  //   element: <Test />,
  //   // element: <></>,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },

  // {
  //   path: 'employees/employee-groups',
  //   element: <EmployeeGroups />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },
  // {
  //   path: 'employees/employee-groups/new',
  //   element: <AddEmployeeGroup />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },
  // {
  //   path: 'employees/employee-groups/:groupKey',
  //   element: <EmployeeGroup />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },

  // {
  //   path: 'employees/activation-codes',
  //   element: <h1>Programs</h1>,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },

  // PROGRAMS
  {
    path: 'programs',
    element: <Programs />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'programs/:programId/details',
    element: <Program />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'programs/:programId/details/plan/new',
    element: <CreateOffer />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'programs/:programId/details/offer/:planId',
    element: <Offer />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'programs/:programId/details/offer/:planId/sponsorships/new',
    element: <SponsorshipsCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'programs/:programId/details/offer/:planId/employee/:employeeId',
    // element: <Employee />,
    element: <></>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'programs/:programId/details/offer/:planId/allocate',
    element: <PlanAllocation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'programs/:programId',
    element: <ProgramCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // Campaigns/Events
  // {
  //   path: 'campaigns',
  //   element: <Campaigns />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },
  // {
  //   path: 'campaigns/new',
  //   element: <CampaignCreation />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },

  // CATEGORIES
  {
    path: 'categories',
    element: <Categories />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'categories/:categoryId',
    element: <Category />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // MERCHANTS
  {
    path: 'merchants',
    element: <Merchants />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'merchants/new',
    element: <MerchantCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // FINANTIAL PERFORMANCE
  {
    path: 'financials',
    element: <Financials />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/transactions',
    element: <Transactions />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/transactions/:transactionId',
    element: <Transaction />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/settlements',
    element: <Settlements />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/settlements/:settlementId',
    element: <Settlement />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/payments',
    element: <Payments />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/payments/:transId',
    element: <Payments />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/program-accounts',
    element: <Wallets />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/program-accounts/:walletAddress',
    element: <AddWalletFunds />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/program-accounts/:walletAddress/transactions',
    element: <Transactions />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'financials/settlements',
    element: <Settlements />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'financials/settlements/:settlementId',
    element: <Settlement />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'receivable/settlements',
    element: <ReceivableSettlements />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },
  {
    path: 'receivable/settlements/:settlementId',
    element: <ReceivableSettlement />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // FINANTIAL PERFORMANCE
  // {
  //   path: 'licenses',
  //   element: <Licenses />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },
  // {
  //   path: 'licenses/generate',
  //   element: <LicenseGenerations />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },

  // CLAIMS
  {
    path: 'claims',
    element: <Claims />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // SUPPORT
  {
    path: 'support',
    element: <Support />,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // SUPPORT
  // {
  //   path: 'simulator',
  //   element: <Simulator />,
  //   // element: <Test />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },

  // PRISEEN
  {
    path: '/priseen',
    element: <PriseenRoutesLayout />,
    children: [
      // Items
      {
        path: 'items',
        element: <Items />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      // {
      //   path: 'items/new',
      //   element: <ItemCreationPage />,
      //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
      //   featureCode: 'vaseelah'
      // },
      {
        path: 'items/:itemId',
        element: <ItemCreationPage />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },

      // Bundles
      {
        path: 'item-bundles',
        element: <BundlesPage />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      {
        path: 'item-bundles/:bundleId/map',
        element: <BundleMappingPage />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      {
        path: 'item-bundles/:bundleId/edit',
        element: <BundleCreationPage />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      {
        path: 'item-bundles/:bundleId/details',
        element: <BundleDetailsPage />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      {
        path: 'item-bundles/:bundleId',
        element: <BundleCreationPage />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },

      // {
      //   path: 'item-bundles/:bundleId',
      //   children: [
      //     { index: true, element: <BundleDetailsPage /> },
      //     { path: 'edit', element: <BundleCreationPage /> }
      //   ],
      //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
      //   featureCode: 'vaseelah'
      // },

      // Tags
      {
        path: 'tags',
        element: <TagsPage />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      // {
      //   path: 'tags/new',
      //   element: <ProgramCreationPage />,
      //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
      //   featureCode: 'vaseelah'
      // },
      // {
      //   path: 'tags/:tagId',
      //   element: <Program />,
      //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
      //   featureCode: 'vaseelah'
      // },

      // Item Categories
      {
        path: 'item-categories',
        element: <ItemCategories />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      // {
      //   path: 'item-categories/new',
      //   element: <ProgramCreationPage />,
      //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
      //   featureCode: 'vaseelah'
      // },
      // {
      //   path: 'item-categories/:categoryId',
      //   element: <Program />,
      //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
      //   featureCode: 'vaseelah'
      // },

      // stores
      {
        path: 'stores',
        element: <Stores />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      // {
      //   path: 'stores/new',
      //   element: <StoreCreationPage />,
      //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
      //   featureCode: 'vaseelah'
      // },
      {
        path: 'stores/:storeId/details',
        element: <Store />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      {
        path: 'stores/:storeId',
        element: <StoreCreationPage />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },

      // catalogues and menus
      {
        path: 'catalogues',
        element: <CataloguesPage />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      {
        path: 'catalogues/:catalogueId/menus',
        element: <Menus />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      {
        path: 'catalogues/:catalogueId/menus/menuId',
        element: <Store />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },

      // app users
      {
        path: 'app-users',
        element: <AppUsers />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      {
        path: 'app-users/:userId',
        element: <AppUserCreation />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },

      // child-accounts
      {
        path: 'accounts',
        element: <ChildAccounts />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      },
      {
        path: 'accounts/:accountId',
        element: <UserCreation />,
        allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
        featureCode: 'vaseelah'
      }
      // {
      //   path: 'accounts/:accountId/details',
      //   element: <Store />,
      //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
      //   featureCode: 'vaseelah'
      // }
    ]
  }
];

//=============================== PRISEEN MERCHANT MENU ITEMS===============================//

export const merchantMenuItems = [
  // {
  //   id: 'deal-managemet',
  //   title: 'Deals',
  //   type: 'item',
  //   url: '/deals',
  //   icon: icons.CampaignIcon,
  //   breadcrumbs: true,
  //   feature_code: 'deal-management'
  // },
  {
    id: 'programs',
    title: 'Programs',
    type: 'item',
    url: '/programs',
    icon: icons.CampaignIcon,
    breadcrumbs: true,
    feature_code: 'programs'
  },

  // {
  //   id: 'campaigns',
  //   title: 'Campaigns & Events',
  //   type: 'item',
  //   url: '/campaigns',
  //   icon: icons.FestivalIcon,
  //   breadcrumbs: true,
  //   feature_code: 'campaigns'
  // },

  {
    id: 'categories',
    title: 'Categories',
    type: 'item',
    url: '/categories',
    icon: icons.CategoryOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'categories'
  },

  {
    id: 'merchants',
    title: 'Merchants',
    type: 'item',
    url: '/merchants',
    icon: icons.StorefrontOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'merchants'
  },

  {
    id: 'receivables',
    title: 'Receivables',
    type: 'collapse',
    url: '/receivables',
    icon: icons.CalculateIcon,
    breadcrumbs: true,
    feature_code: 'receivables-management',
    children: [
      {
        id: 'receivable-settlements',
        title: 'Settlements',
        type: 'item',
        url: '/receivable/settlements',
        breadcrumbs: true,
        feature_code: 'receivables-management'
      }
    ]
  },

  {
    id: 'claim-management',
    title: 'Claims',
    type: 'item',
    url: '/claims',
    icon: icons.ReceiptLongOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'claim-management'
  },

  // {
  //   id: 'employees',
  //   title: 'Employee Management',
  //   type: 'collapse',
  //   url: '/employees',
  //   icon: icons.GroupsIcon,
  //   breadcrumbs: true,
  //   feature_code: 'employee-management',
  //   children: [
  //     {
  //       id: 'employees',
  //       title: 'List',
  //       type: 'item',
  //       url: '/employees',
  //       breadcrumbs: true,
  //       feature_code: 'employee-management'
  //     },
  //     {
  //       id: 'employee-groups',
  //       title: 'Groups',
  //       type: 'item',
  //       url: '/employees/employee-groups',
  //       breadcrumbs: true,
  //       feature_code: 'employee-management'
  //     }
  //     // {
  //     //   id: 'programs-by-consumer-group',
  //     //   title: 'Programs',
  //     //   type: 'item',
  //     //   url: '/employees/activation-codes',
  //     //   breadcrumbs: true,
  //     //   feature_code: 'employee-management'
  //     // }
  //   ]
  // },

  {
    id: 'financials',
    title: 'Financials',
    type: 'collapse',
    url: '/financials',
    icon: icons.CalculateIcon,
    breadcrumbs: true,
    feature_code: 'financial-management',
    children: [
      {
        id: 'settlements',
        title: 'Settlements',
        type: 'item',
        url: '/financials/settlements',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'wallets',
        title: 'Program Accounts',
        type: 'item',
        url: '/financials/program-accounts',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'transactions',
        title: 'Transactions',
        type: 'item',
        url: '/financials/transactions',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'payments',
        title: 'Payments',
        type: 'item',
        url: '/financials/payments',
        breadcrumbs: true,
        feature_code: 'financial-management'
      }
    ]
  },

  {
    id: 'priseen',
    title: 'Items',
    type: 'collapse',
    url: '/priseen/items',
    icon: icons.FastfoodOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'priseen-management',
    children: [
      {
        id: 'items',
        title: 'Items',
        type: 'item',
        url: '/priseen/items',
        breadcrumbs: true,
        feature_code: 'priseen-management'
      },
      {
        id: 'item-bundles',
        title: 'Bundles',
        type: 'item',
        url: '/priseen/item-bundles',
        breadcrumbs: true,
        feature_code: 'priseen-management'
      },
      {
        id: 'tags',
        title: 'Tags',
        type: 'item',
        url: '/priseen/tags',
        breadcrumbs: true,
        feature_code: 'priseen-management'
      },
      {
        id: 'categories',
        title: 'Categories',
        type: 'item',
        url: '/priseen/item-categories',
        breadcrumbs: true,
        feature_code: 'priseen-management'
      }
    ]
  },

  {
    id: 'stores',
    title: 'Stores',
    icon: icons.StorefrontIcon,
    type: 'item',
    url: '/priseen/stores',
    breadcrumbs: true,
    feature_code: 'priseen-management'
  },

  {
    id: 'app-users',
    title: 'App Users',
    icon: icons.GroupIcon,
    type: 'item',
    url: '/priseen/app-users',
    breadcrumbs: true,
    feature_code: 'priseen-management'
  },

  {
    id: 'catalogues',
    title: 'Catalogues & Menus',
    icon: icons.MenuBookOutlinedIcon,
    type: 'item',
    url: '/priseen/catalogues',
    breadcrumbs: true,
    feature_code: 'priseen-management'
  },

  {
    id: 'support',
    title: 'Support',
    type: 'item',
    url: '/support',
    icon: icons.PaymentIcon,
    breadcrumbs: true,
    feature_code: 'support'
  }

  // {
  //   id: 'simulator',
  //   title: 'Simulator',
  //   type: 'item',
  //   url: '/simulator',
  //   icon: icons.TabletSmartphone,
  //   breadcrumbs: true,
  //   feature_code: 'simulator'
  // }
];
